import enkrypt from "../assets/media/icons/wallets/enkrypt.png";
import zerion from "../assets/media/icons/wallets/zerion.png";
import rainbow from "../assets/media/icons/wallets/rainbow.png";
import phantom from "../assets/media/icons/wallets/phantom.png";
import xDEFI from "../assets/media/icons/wallets/xdefi.png";
import okx from "../assets/media/icons/wallets/okx.png";
import tokenPocket from "../assets/media/icons/wallets/tokenpocket.png";
import frontier from "../assets/media/icons/wallets/frontier.png";
import talisman from "../assets/media/icons/wallets/talisman.png";
import trust from "../assets/media/icons/wallets/trust.png";
import metamask from "../assets/media/icons/wallets/metamask.png";
import coinbase from "../assets/media/icons/wallets/coinbase.png";
import exodus from "../assets/media/icons/wallets/exodusicon.png";

export const WalletLists = [
  {
    id: 1,
    title: "Enkrypt",
    urlChrome:
      "https://chromewebstore.google.com/detail/enkrypt-crypto-wallet-eth/kkpllkodjeloidieedojogacfhpaihoh?pli=1",
    urlFirefox: "https://addons.mozilla.org/en-US/firefox/addon/enkrypt/",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: enkrypt,
  },
  {
    id: 2,
    title: "Zerion",
    urlChrome:
      "https://chromewebstore.google.com/detail/zerion-wallet-for-web3-nf/klghhnkeealcohjjanjjdaeeggmfmlpl?%24web_only=true&utm_source=zerion_homepage&utm_campaign=zerion-extension&utm_medium=homepage",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: zerion,
  },
  {
    id: 3,
    title: "Rainbow",
    urlChrome: "https://chromewebstore.google.com/detail/rainbow/opfgelmcmbiajamepnmloijbpoleiama",
    urlFirefox: "https://addons.mozilla.org/en-US/firefox/addon/rainbow-extension/",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: rainbow,
  },
  {
    id: 4,
    title: "Phantom",
    urlChrome: "https://chromewebstore.google.com/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa",
    urlFirefox: "https://addons.mozilla.org/en-US/firefox/addon/phantom-app/",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: phantom,
  },
  {
    id: 5,
    title: "XDEFI",
    urlChrome: "https://chromewebstore.google.com/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: xDEFI,
  },
  {
    id: 6,
    title: "OKX",
    urlChrome: "https://chromewebstore.google.com/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: okx,
  },
  {
    id: 7,
    title: "TokenPocket",
    urlChrome:
      "https://chromewebstore.google.com/detail/tokenpocket-web3-nostr-wa/mfgccjchihfkkindfppnaooecgfneiii?hl=en",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: tokenPocket,
  },
  {
    id: 8,
    title: "Frontier",
    urlChrome: "https://chromewebstore.google.com/detail/frontier-wallet/kppfdiipphfccemcignhifpjkapfbihd",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: frontier,
  },
  {
    id: 9,
    title: "Talisman",
    urlChrome: "https://chromewebstore.google.com/detail/talisman-ethereum-and-pol/fijngjgcjhjmmpcmkeiomlglpeiijkld",
    urlFirefox: "https://addons.mozilla.org/en-US/firefox/addon/talisman-wallet-extension/",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: talisman,
  },
  {
    id: 10,
    title: "Trust",
    urlChrome: "https://chromewebstore.google.com/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: trust,
  },
  {
    id: 11,
    title: "Metamask",
    urlChrome: "https://chromewebstore.google.com/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn",
    urlFirefox: "https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: metamask,
  },
  {
    id: 12,
    title: "Coinbase",
    urlChrome:
      "https://chromewebstore.google.com/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad?hl=en&authuser=0",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: coinbase,
  },
  {
    id: 13,
    title: "Exodus",
    urlChrome: "https://chromewebstore.google.com/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno",
    urlFirefox: "",
    urlBrave: "#",
    urlEdge: "#",
    urlOpera: "#",
    urlSafari: "#",
    logo: exodus,
  },
];
